"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalTime = void 0;
class LocalTime {
    constructor(obj) {
        this.hour = obj.hour;
        this.minute = obj.minute;
    }
    static fromMinutesSinceMidnight(minutesSinceMidnight) {
        const clamped = Math.min(Math.max(0, minutesSinceMidnight), 1439);
        const minute = clamped % 60;
        const hour = (clamped - minute) / 60;
        return new LocalTime({
            hour,
            minute,
        });
    }
    compareTo(that) {
        return (this.hour * 60 + this.minute) - (that.hour * 60 + that.minute);
    }
    toString() {
        const min = this.minute <= 9 ? "0" + this.minute : this.minute;
        return this.hour.toString() + ":" + min;
    }
    get minutesSinceMidnight() {
        return this.hour * 60 + this.minute;
    }
}
exports.LocalTime = LocalTime;
//# sourceMappingURL=local-time.js.map